import { Navigate } from "react-router-dom";
import { AppService } from "services";

export const AuthGuard: React.FC = ({ children }) => {
  if (AppService.isLoggedIn()) return <>{children}</>;

  return <Navigate replace to="/login" />;
};
